import { Drawer } from '@ui/lib/park/ui/drawer';

import { TokenOption } from './TokenOption';
import { CollateralTokenPickerProps } from './type';

export const PickerDrawer = ({
  onSelect,
  children,
  payableTokens,
  title,
}: CollateralTokenPickerProps) => {
  return (
    <Drawer.Root lazyMount unmountOnExit modal={false} direction="bottom">
      <Drawer.Trigger asChild>{children}</Drawer.Trigger>
      <Drawer.Backdrop />
      <Drawer.Positioner>
        <Drawer.Content bg="black.lv3">
          <Drawer.Header
            flexDir="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Drawer.Title>{title}</Drawer.Title>
            <Drawer.CloseTrigger />
          </Drawer.Header>

          <Drawer.Body
            p="20px 16px 48px 16px"
            display="flex"
            flexDir="column"
            gap="16px"
            borderTop="none"
          >
            <Drawer.Context>
              {(context) =>
                payableTokens.map((token) => (
                  <TokenOption
                    key={token.address}
                    token={token}
                    onClick={() => {
                      onSelect(token);
                      context.setOpen(false);
                    }}
                  />
                ))
              }
            </Drawer.Context>
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
};
